import React from 'react';
import { Column } from 'types/common';

import CopyUrlButton from '../component/copy-url-button';
import RowText from '../component/row-text';
import { formatAttendeeRoles } from '../component/ron-schedule-meeting/utils';
import { NewOrderPartyType } from 'types/order';

export type ColumnsType = { [key: string]: Column };

export type scheduleMettingTokens = {
  id: string;
  parties: any[];
  date: string;
  init_time: string;
  end_time: string
}

export type tableRowComponent = {
  party_info?: NewOrderPartyType;
  url: string;
  token: string;
  email: string
}

type RendererParams = {
  row: tableRowComponent;
  column: Column;
  index: number;
  indexRow?: number
};

export const generateLenderCreditsColumns = (
  t,
  theme,
  onCopy
): ColumnsType => {
  const headerColor = theme.palette.mode === 'dark' ? theme.palette.text.secondary : theme.palette.primary.light;

  return {
    Name: {
      header: {
        title: t('ron:attendee-name'),
        align: 'center',
        textColor: headerColor
      },
      renderer: ({ row }: RendererParams) => (
        <RowText text={row?.party_info?.name || ''} />
      )
    },
    Email: {
      header: {
        title: t('ron:attendee-email'),
        align: 'center',
        textColor: headerColor
      },
      renderer: ({ row }: RendererParams) => (
        <RowText text={row.email || t('ron:not-email')} />
      )
    },
    roles: {
      header: {
        title: t('ron:attendee-roles'),
        align: 'center',
        textColor: headerColor
      },
      renderer: ({ row }: RendererParams) => (
        <RowText text={formatAttendeeRoles(row.party_info?.kinds)} />
      )
    },
    copy: {
      header: {
        title: t('ron:attendee-actions'),
        align: 'center',
        textColor: headerColor
      },
      renderer: ({ row }: RendererParams) => (
        <CopyUrlButton label={t('ron:copy-url')} onClick={() => onCopy(row.url)} />
      )
    },
  };
};
